import MasterTable from "../../views/dashboard/widget/MasterTabel";
import { useGlobalState } from "../../services/hostelConst.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getStudentDetails,
  getStudentList,
  deleteStudent,
  updateStudentStatus,
} from "../../services/Academic-Services";
import AddClassesForm from "../../components/FormComponents/AddClasses.js";
import AddStudentForm from "../FormComponents/AddStudentForm";
const StudentsTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });

    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getStudentList}
        deleteRow={deleteStudent}
        updateStatus={updateStudentStatus}
        AddForm={AddStudentForm}
        tab1={"Academic"}
        tab2={"Student"}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
      />
    </>
  );
};

export default StudentsTable;
